/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExhibitionWithTranslationsPartial } from '../../models/exhibition-with-translations-partial';

export interface EditorUpdateExhibition$Params {
  id: string;
      body?: ExhibitionWithTranslationsPartial
}

export function editorUpdateExhibition(http: HttpClient, rootUrl: string, params: EditorUpdateExhibition$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, editorUpdateExhibition.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

editorUpdateExhibition.PATH = '/editor/exhibitions/{id}';
